import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth/auth.service';

/**
 * Modern functional HTTP interceptor for authentication
 * Adds JWT token to requests and handles auth errors
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const toastr = inject(ToastrService);
    const authService = inject(AuthService);

    // Add JWT token if present
    const jwtToken = localStorage.getItem('jwtToken');
    let authReq = req;

    if (jwtToken) {
        authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${jwtToken}`
            }
        });
    }

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            // Handle different error status codes
            switch (error.status) {
                case 0:
                    toastr.error('Impossible de se connecter au serveur', 'Erreur réseau');
                    break;
                case 400:
                    toastr.warning(error.error?.message || 'Requête invalide');
                    break;
                case 401:
                    toastr.error('Votre session a expiré. Veuillez vous reconnecter.');
                    authService.logout();
                    router.navigate(['/login']);
                    break;
                case 403:
                    toastr.error('Accès refusé', 'Erreur 403');
                    break;
                case 500:
                    toastr.error('Une erreur interne est survenue', 'Erreur serveur');
                    break;
                default:
                    toastr.error(error.error?.message || 'Une erreur est survenue');
                    break;
            }

            return throwError(() => error);
        })
    );
};
